import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.dev';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  public configuration: any;

  constructor() {}

  // APP_INITIALIZER must return a Promise
  loadConfiguration(): Promise<any> {
    return new Promise((resolve) => {
      this.configuration = environment;
      resolve(true);
    });
  }

  getConfiguration() {
    return this.configuration;
  }
}
